import { SearchProduct } from '@winelivery-org/wl-client-sdk-js/dist/models/search';
import _ from 'lodash';
import { useTranslations } from 'next-intl';
import * as React from 'react';
import AddressModal from '../../app/[locale]/shop/components/commons/AddressModal/AddressModal';
import useAddressSearch from '../../app/[locale]/shop/components/commons/AddressModal/hook';
import { useLocalization } from '@/hooks/useLocalization';
import * as GTM from '../../lib/GTM';
import useCartStore from '../../stores/cart/store';
import CartCounter from './CartCounter';
import FeaturedEcommerceButton from './FeaturedEcommerceButton';

export interface IProps {
  product: SearchProduct;
  single?: boolean;
  large?: boolean;
  modalId?: string;
}

const AddToCartButton: React.FC<IProps> = (props) => {
  const t = useTranslations('common');

  const { azs, location } = useLocalization();
  const cart = useCartStore();
  const { updateGlobalLocation } = useAddressSearch('');

  let deliveryType = 'express';
  if (azs.length > 0) {
    deliveryType = azs[0].deliveryType;
  }

  const addProductToCart = (): void => {
    GTM.addToCart(props.product);
    cart.addItem(props.product);
  };

  const isProductInCart = () => {
    const { product } = props;
    if (cart.items.length > 0) {
      return _.find(cart.items, (item) => {
        return item.product.id === product.id;
      });
    } else {
      return false;
    }
  };

  const { product } = props;

  const classNames = [
    'button',
    props.single ? 'btn-primary' : 'btn-primary-o',
    props.large ? 'btn-md leading-10' : 'btn-sm leading-8',
    'my-0',
    'product-btn',
  ];

  if (product.deliveryType !== deliveryType) {
    return <FeaturedEcommerceButton product={product} />;
  }

  // Opens choose address Modal
  if (!location?.coordinates.lat && !location?.coordinates.lng) {
    return (
      <AddressModal
        onChangeAddress={updateGlobalLocation}
        renderTrigger={({ open }) => (
          <button
            id="add_to_cart_button"
            className={classNames.join(' ')}
            onClick={open}
          >
            {t('AddToCartButton.add-to-cart')}
          </button>
        )}
      />
    );
  }

  if (!product.inStock) {
    return (
      <button
        id="add_to_cart_button"
        className="button btn-primary btn-sm leading-8 my-0 product-btn"
        disabled
      >
        {t('AddToCartButton.not-available')}
      </button>
    );
  }

  return !isProductInCart() ? (
    <button
      id="add_to_cart_button"
      className={classNames.join(' ')}
      onClick={() => addProductToCart()}
    >
      {t('AddToCartButton.add-to-cart')}
    </button>
  ) : (
    <div className={props.large ? 'mb-2' : ''}>
      <CartCounter product={product} />
    </div>
  );
};

export default AddToCartButton;
